import * as React from 'react';

import {Field, Form, Formik} from 'formik';

import {Checkbox, Radio} from 'antd';

import {List} from '@common/typescript/objects/List';

import SimpleMap from '@app/components/UI/SimpleMap/SimpleMap';
import {StatesListItem} from '@app/objects/StatesListItem';
import {rest} from '@app/components/Api';
import {ListOption} from '@app/objects/SidebarProps';
import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';

import '@app/scss/components/vetMapBlock.scss';

interface Opportunity {
	name: string;
	stateId: number;
	fullPartTime: number;
	isFeatured: boolean;
	company: number;
	state: string;
	id: number;
}

const VeterinarianMapBlock = ({link}) => {
	const opportunitiesList: ListOption[] = [];
	const [currentState, setCurrentState] = React.useState<string>('');
	const [states, setStates] = React.useState<StatesListItem[]>([]);
	const stateListOptions: ListOption[] = [];
	const [currentCity, setCurrentCity] = React.useState( '');
	const [stateAreas, setStateAreas] = React.useState<Opportunity[]>([]);
	const [checked, setChecked] = React.useState(false);
	const transformStateList = () => {
		states && states.map((item, index) => {
			stateListOptions.push({value: item.name});
		});
	};

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states/opportunities')
			.then(res => setStates(res.list));
	}, []);

	React.useEffect(() => {
		rest.get<List<Opportunity>>(`v1/opportunities/${currentState}`)
			.then((res) => {
				setStateAreas(res.list);
			});
	}, [currentState]);

	const transfomOpportunities = () => {
		stateAreas && stateAreas.map((item, index) => {
			opportunitiesList.push({value: String(item.id), label: item.name});
		});
	};

	transformStateList();
	transfomOpportunities();
	return (
		<div className="vet-map-block">
			<div className="vet-map-block__content">

					<Formik
						onSubmit={(values) => {
							console.log(values);
						}}
						initialValues={{state: '', opportunity: '', notListed: false}}

						render={(formikBag) => {

							return (
								<Form
									className="vet-map-block__form"
								>
									<div className="vet-map-block__menu">
										<SearchFieldAuto
											name="state"
											placeholder= "Search by state"
											listOptions={[{value: '', label: 'All opportunities'}, ...stateListOptions]}
											formikBag={formikBag}
											onSelect = {(value, option) => {
												formikBag.setFieldValue('state', value === '' ? 'All opportunities' : value);
												setCurrentState(value);
												setChecked(false);
												setCurrentCity('');
												formikBag.setFieldValue('opportunity', '');
											}}
											onChange={(value) => {
												formikBag.setFieldValue('state', value);
												!value &&
												setCurrentState('');
												setCurrentCity('');
												setChecked(false);
												formikBag.setFieldValue('opportunity', '');
											}}
											searchButton={false}
											allowClear={true}
										/>
										<Field
											name="opportunity"
											render={(field) => {
												return (
													<Radio.Group
														// @ts-ignore
														options={opportunitiesList}
														// defaultValue={opportunitiesList.length && opportunitiesList[0].label}
														value={currentCity}
														onChange={(e) => {
															setCurrentCity(e.target.value);
															setChecked(false);
															formikBag.setFieldValue('opportunity', e.target.value);
														}}
														style={{display: 'flex', flexDirection: 'column'}}
													/>
												);
											}}
										/>

										<a href={link} target="_blank" className="btn btn-md btn-primary">
											Apply now
										</a>

										<Field
											name="notlisted"
											render = {(field) => {
												return(
													<Checkbox
														onChange={() => {
															setChecked(!checked);
															setCurrentCity('');
															formikBag.setFieldValue('notlisted', !checked);
														}}
														checked={checked}
														value="my area is not listed"
													>
														My area is not listed
													</Checkbox>
												);
											}}
										/>

									</div>
									<div className="vet-map-block__map">
										<h2>
											Currently looking for compassionate veterinarians in the following areas
										</h2>
										<p>
											If you don’t see your area listed, we would still love to talk with you about opportunities to work with us—so apply now!
										</p>
										<div className="vet-map-block__map-interactive">
											<SimpleMap
												states={states}
												getTooltip={state => state.opportunities && state.opportunities === 1 ? `${state.opportunities} opportunitiy` : `${state.opportunities} opportunities` }
												getFillColor={state => state.opportunities && state.opportunities > 0 ? (state.isFeatured ? '#9c8cae' : '#c4bacf') : '#e1dce6'}
												onClick={(state) => {
													setCurrentState(state.name);
													formikBag.setFieldValue('state', state.name);
													setCurrentCity('');
													setChecked(false);
													formikBag.setFieldValue('opportunity', '');
												}}
											/>
										</div>
									</div>

								</Form>
							);
						}}
					/>
			</div>
		</div>
	);
};

export default VeterinarianMapBlock;